<h2 class="section__title">{{title}}</h2>
